import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/global.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lazyload from '@/directives/lazyload'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.directive('lazyload', lazyload)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')


